<template>
    <div class="video-wrap" :key="'key-' + this.$route.params.videoId" :class="{'video-fullscreen': isFullscreen}">

        <div id="video-wra">

            <div id="fullVid" :class="{ 'video-finished' : videoFinished}">

                <!--  <div :class="{'spinner': !isLoaded}"></div> -->
                <div @mouseover="hideControls = false">
                    <div class="video-pause-overlay" v-if="!isPlaying" @click="playVideo()"></div>
                    <div class="fullscreen-video-overlay" v-if="isFullscreen && videoFinished"></div>
                    <youtube id="youtube-iframe" ref="youtube" :video-id="video.youtubeId"
                             :player-vars="defaultPlayerVars" player-width="100%" player-height="100%"
                             @playing="playing" @paused="paused" @ended="videoEnded" @ready="videoReady"></youtube>
                </div>

                <div class="player-controls container" :class="{ 'hide-controls' : hideControls }">
                    <div id="progress-bar" @mouseover="hideControls = false">
                        <div class="row">
                            <div class="col-sm-10">
                                <!-- https://github.com/NightCatSama/vue-slider-component -->
                                <vue-slider :value="currentTime" :max="duration" tooltip="hover"
                                            @callback="sliderUpdate" :speed='parseInt(0)' height="15"
                                            :dot-size="parseInt(21)">
                                    <div class="vue-slider-tooltip custom-tooltip" slot="tooltip"
                                         slot-scope="{ value }">
                                        {{ value | formatTime }}
                                    </div>
                                </vue-slider>
                            </div>
                            <div class="col-sm-2">
                            <span class="video-duration">
                                <span>{{currentTime | formatTime}}</span> <span>/ {{ duration | formatTime }}</span>
                            </span>
                            </div>
                        </div>
                    </div>

                    <div class="player-controls-btns" id="custom-player-controls">
                        <button class="btn btn-control" @click="playVideo" v-show="playVid"><i
                                class="icon-play-button"></i></button>
                        <button class="btn btn-control" @click="pauseVideo" v-show="!playVid"><i class="icon-pause"></i>
                        </button>
                        <button class="btn btn-control" @click="muteVideo" v-show="!muted"
                                @mouseover="hideControls = false"><i class="icon-volume"></i></button>
                        <button class="btn btn-control" @click="unMuteVideo" v-show="muted"
                                @mouseover="hideControls = false"><i class="icon-mute-b"></i></button>
                        <button class="btn btn-control" @click="skipToEnd" @mouseover="hideControls = false"><i
                                class="icon-skip"></i></button>
                        <button class="btn btn-control pull-right responsiveFullscreen" @click="toggleFullscreen"><i
                                    class="icon-expand"></i></button>
                        <div class="group-btn" @mouseover="hideControls = false">
                            <h3>{{video.title}}</h3><span class="video-text-slash">/</span><span class="video-text">{{video.description}}</span>
                            <button class="btn btn-control pull-right" @click="toggleFullscreen"><i
                                    class="icon-expand"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="videoFinished && video.options" class="video-options-wrap">
                <div class="container" v-if="video.options.length > 1"><h2 class="video-option-title">
                    {{video.description}}</h2></div>
                <div class="container">
                    <div v-for="(option,index) in video.options" @click="nextVideo(option.videoId)"
                         class="video-option-extra">
                        <video-thumbnail :video="VideoType.questions[option.videoId]" :year="year" :type="type" thumbnailFormat="video-option">
                        </video-thumbnail>
                        <div class="option-or" v-if="index == 0">
                            OR
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="videoFinished && video.options.length < 1">
                <div class="cta-to-map" @click="finish">
                    <h3>{{video.endMessage}}</h3>
                    <h4>See your journey... <i class="icon-arrow"></i></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlider from 'vue-slider-component'
    import VideoThumbnail from '../global/VideoThumbnail'

    export default {
        name: 'Video',
        props: ['year', 'type', 'videoId', 'VideoData'],
        components: {
            VueSlider,
            VideoThumbnail
        },
        data: function () {
            return {
                // Set current video based on parameter
                video: null,
                currentTime: 0,
                playVid: true,
                hideControls: false,
                muted: false,
                defaultPlayerVars: {
                    controls: 0,
                    disablekb: 1,
                    showinfo: 0,
                    height: "100%",
                    width: "100%",
                    rel: 0,
                    fs: 1,
                    color: "white",
                    vq: "hd1080"
                },
                duration: 0,
                // update based on ended event
                videoFinished: false,
                currentTimeUpdater: null,
                isLoaded: false,
                isPlaying: false,
                isFullscreen: false,
                iframeElement: null,
                VideoType: null
            }
        },
        methods: {
            // https://developers.google.com/youtube/iframe_api_reference#Functions
            playVideo() {
                this.player.playVideo()
                this.playVid = false;
                this.hideControls = true;
            },
            pauseVideo() {
                if (this.currentTimeUpdater) {
                    clearInterval(this.currentTimeUpdater);
                }
                this.player.pauseVideo();
                this.playVid = true;
                this.isPlaying = false;
                this.hideControls = false;
            },
            muteVideo() {
                this.player.mute();
                this.muted = true;
            },
            unMuteVideo() {
                this.player.unMute();
                this.muted = false;
            },
            toggleFullscreen() {
                var iframe = this.iframeElement;

                if (!this.isFullscreen) {
                    this.isFullscreen = true;
                    this.$store.commit('setFullscreen', true);
                    var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.msRequestFullscreen || iframe.webkitRequestFullScreen;
                    if (requestFullScreen) {
                        requestFullScreen.bind(iframe)();
                    }
                } else {
                    this.isFullscreen = false;
                    this.$store.commit('setFullscreen', false);
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                }
            },
            videoReady(player) {
                this.currentTime = 0;
                this.duration = this.$refs.youtube.player.getDuration();
                this.isLoaded = true;
                this.iframeElement = document.getElementById("video-wra");
            },
            skipToEnd() {
                if (this.currentTimeUpdater) {
                    clearInterval(this.currentTimeUpdater);
                }
                let duration = this.player.getDuration();
                this.player.seekTo(duration);
                this.currentTime = duration;

            },
            playing() {
                this.currentTimeUpdater = setInterval(this.updateCurrentTime, 100);
                this.isPlaying = true;
            },
            paused() {
                this.isPlaying = false;
            },
            sliderUpdate(value) {
                this.currentTime = value;
                this.player.seekTo(value);
            },
            //fired when video is finished
            videoEnded() {
                clearInterval(this.currentTimeUpdater);
                this.videoFinished = true;
                this.isFullscreen = false;
                this.$store.commit('setFullscreen', false);
            },
            nextVideo(videoId) {
                let complete = this.$store.getters.getCompleted(this.year, this.type);
                // if we have not completed
                if (!complete) {
                    // Track video path for first route @TODO
                    this.$store.dispatch('videoPath', {
                        id: videoId,
                        year: this.year,
                        type: this.type
                    });
                }

                this.$router.push({
                    name: 'Video',
                    params: {
                        year: this.year,
                        type: this.type,
                        videoId: videoId
                    }
                });
            },
            finish() {
                let complete = this.$store.getters.getCompleted(this.year, this.type);

                // reset the last video back to 1 once we have completed all
                this.$store.commit('setLastVideoID', {year: this.year, type: this.type, videoId: 1});
                var completed = {
                    year: this.year, 
                    type: this.type
                }
                this.$store.commit('setCompleted', completed);
                this.$router.push({
                    name: 'VideoMap',
                    params: {
                        year: this.year,
                        type: this.type
                    }
                });
            },
            updateCurrentTime() {
                this.currentTime = this.player.getCurrentTime();
            },
        },
        computed: {
            player() {
                return this.$refs.youtube.player
            },
        },
        created: function () {
            // Remove fullscreen 
            this.isFullscreen = false;
            this.$store.commit('setFullscreen', false);
            // window.addEventListener('keyup', (evt) => {
            //     console.log(evt);
            //     if (evt.keyCode === 27) {
            //         this.isFullscreen = false;
            //         this.$store.commit('setFullscreen', false);
            //     }
            // });
            // document.addEventListener('fullscreenchange', (evt) => {
            //     console.log(evt);
            //     console.log(document.fullscreenElement);
            // });

            // Load video if exists
            this.VideoType = this.VideoData[this.year][this.type];
            console.log(this.VideoData);
            this.video = this.VideoData[this.year][this.type].questions[this.videoId];

            this.video.year = this.year;
            this.video.type = this.type;
            console.log(this.video);
            // Tracking videos and last viewed
            this.$store.dispatch('addVideoWatch', this.video);

            this.$store.commit('setLastVideoID', {year: this.year, type: this.type, videoId: this.videoId});
        },
        filters: {
            formatTime(time) {
                if (time == 0) {
                    return "0:00";
                }
                time = Math.round(time);

                var minutes = Math.floor(time / 60),
                    seconds = time - minutes * 60;

                seconds = seconds < 10 ? '0' + seconds : seconds;

                return minutes + ":" + seconds;
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    #youtube-iframe {
        width: 100%;
        height: 100%;
    }

    .video-wrap {
        position: relative;
    }

</style>



// WEBPACK FOOTER //
// src/components/pages/Video.vue